export default {
  devices: [],
  onlineCount: 0,
  offlineCount: 0,
  totalCount: 0,
  cartridgeAlmostEmptyCount: 0,
  cartridgeEmptyCount: 0
};
